module.exports = __webpack_public_path__ + "img/portrait-075.c53b43d7.jpg";